"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiaryEntryTypes = void 0;
var DiaryEntryTypes;
(function (DiaryEntryTypes) {
    DiaryEntryTypes["BOOKING"] = "booking";
    DiaryEntryTypes["TRAVEL"] = "travel";
})(DiaryEntryTypes = exports.DiaryEntryTypes || (exports.DiaryEntryTypes = {}));
